// extracted by mini-css-extract-plugin
export default {"wrapper":"RadioGroup_wrapper__A9+jP","vertical":"RadioGroup_vertical__kgqxS"};